import React, { createContext, useContext, useState } from "react";

interface ModalContextType {
  showUnsubscribeModal: boolean;
  setShowUnsubscribeModal: (value: boolean) => void;
}

// Create the context with an initial value as null, and handle undefined checks.
const ModalContext = createContext<ModalContextType | undefined>(undefined);

const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);

  return (
    <ModalContext.Provider value={{ showUnsubscribeModal, setShowUnsubscribeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

const useModalContext = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};

export { ModalContext, ModalProvider , useModalContext};
